const messages = {
  cancel_payment: 'Annuler paiement',
  contact_saved: 'Information de contact sauvegarder avec succès.',
  contact_saved_error: 'Désolé une erreur s\'est produite lors de la sauvegarde des informations de contact.',
  payment_saved_error: 'Désolé une erreur s\'est produite le paiement.',
  relation_saved: 'Information de relation sauvegarder avec succès.',
  relation_saved_error: 'Désole une erreur s\'est produite lors de la sauvegarde des informations de relation.',
  contact_updated: 'Mis a jour de vos informations de contact effectuer avec succès.',
  invoice_updated: 'Facture mise à jour avec succès.',
  invoice_saved: 'Facture sauvegardée avec succès.',
  contacts_deleted: 'Contacts supprimés avec succès.',
  relation_deleted: 'Relation supprimée avec succès.',
  invoices_deleted: 'Factures annulées avec succès.',
  ticket_deleted: 'Billet supprimé avec succès.',
  ticket_deleted_error: 'Erreur lors de la suppression du billet.',
  ticket_created: 'Billet créé avec succès.',
  ticket_created_error: 'Erreur lors de la création du billet.',
  ticket_sent: 'Billets envoyés avec succès.',
  ticket_sent_error: 'Erreur lors de l\'envoi des billets.',
  invoices_cancelled: 'Factures cancellées avec succès.',
  invoices_cancelled_error: 'Erreur lors de la cancellation des factures.',
  invoice_sent: 'Facture envoyée avec succès.',
  invoice_sent_error: 'Erreur lors de l\'envoi de la facture.',
  contact_updated_error: 'Désole, une erreur s\'est produite lors de la mise à jour de vos informations de contact.',
  recurring_saved: 'Abonnement enregistré avec succès.',
  recurring_saved_error: 'Erreur lors de l\'enregistrement de l\'abonnement.',
  recurring_updated: 'Abonnement mis à jour avec succès.',
  recurring_updated_error: 'Erreur lors de la mise à jour de l\'abonnement.',
  recurring_deleted: 'Abonnement supprimé avec succès.',
  recurring_deleted_error: 'Erreur lors de la suppression de l\'abonnement.',
  recurring_stopped: 'Abonnement arrêté.',
  recurring_resumed: 'Abonnement repris.',
  organisation_added: '%organisation% ajouter à vos organisations.',
  organisation_added_error: 'Deole une erreur s\'est produite lors de l\'ajout de l\'organisation %organisation%.',
  organisation_removed: 'L\'organisation %organisation% a été retirée de la liste de vos organisations avec succès.',
  organisation_updated: 'Organisation mise à jour avec succès.',
  organisation_updating_error: 'Une erreur s\'est produite lors de la mise à jour du status du partage de vos information avec l\'organisation %organisation%.',
  sharing_info_updated: 'Statut du partage de vos information avec l\'organisation %organisation% mis à jour avec succès.',
  sharing_info_updated_error: 'Une erreur s\'est produite lors de la mise à jour du status du partage de vos information avec l\'organisation %organisation%.',
  wrong_credential: 'Mot de passe ou nom usagé erroné.',
  login_success: 'Vous êtes maintenant connecté.',
  email_sent_verification: 'Un courriel de confirmation vous a été envoyé.',
  email_sent_reset: 'Un courriel contenant un lien pour réinitialiser votre mot de passe vous a été envoyé.',
  credential_error: 'Désolé une erreur s\'est produite.',
  password_changed: 'Votre mot de passe a été mis à jour avec succès.',
  filter_saved_error: 'Une erreur est survenue lors de la sauvegarde des filtres',
  filter_saved_success: 'Filtre sauvegardé avec succès.',
  contact_merged_error: 'Contacts combinés avec succès.',
  contact_merged: 'Erreur lors de la combinaison des contacts',
  field_cant_be_empty: 'Ce champ ne peut être vide.',
  customfield_saved: 'Champ personnalisé sauvegardé.',
  customfield_saved_error: 'Erreur durant la sauvegarde du champ personnalisé.',
  customfield_deleted: 'Champ personnalisé supprimé.',
  customfield_deleted_error: 'Erreur durant la suppression du champ personnalisé.',
  customfield_edited: 'Champ personnalisé sauvegardé.',
  customfield_edited_error: 'Erreur durant la sauvegarde du champ personnalisé.',
  group_saved: 'Groupe sauvegardé.',
  group_saved_error: 'Erreur durant la sauvegarde du groupe.',
  group_deleted: 'Groupe supprimé.',
  group_deleted_error: 'Erreur durant la suppression du groupe.',
  credit_card_added: 'Carte de crédit sauvegardé avec succès.',
  credit_card_deleted: 'Carte de crédit supprimé avec succès.',
  bank_account_added: 'Compte de banque sauvegardé avec succès.',
  bank_account_deleted: 'Compte de banque supprimé avec succès.',
  bank_account_deleted_error: 'Erreur lors de la suppression du compte banquaire.',
  saving_layout: 'Sauvegarder disposition prédéfinie',
  saving_filter: 'Sauvegarder filtre prédéfini',
  preset_layout_saved: 'Disposition prédéfinie sauvée avec succès.',
  preset_filter_saved: 'Filtre prédéfini sauvegardé avec succès.',
  preset_layout_deleted: 'Disposition prédéfinie supprime avec succès.',
  preset_filter_deleted: 'Filtre prédéfini supprimé avec succès.',
  preset_layout_deleted_error: 'Erreur durant la suppression de la disposition.',
  preset_filter_deleted_error: 'Erreur durant la suppression du filtre.',
  preset_layout_saved_error: 'Erreur durant la sauvegarde de la disposition.',
  preset_filter_saved_error: 'Erreur durant la sauvegarde du filtre.',
  department_saved: 'Département sauvegardé',
  department_saved_error: 'Erreur durant la sauvegardé du département',
  department_deleted: 'Département supprimé',
  department_deleted_error: 'Erreur durant la suppresion du département',
  account_saved: 'Sauvegarder',
  account_saved_error: 'Erreur durant la sauvegarde du compte',
  account_deleted: 'Compte supprimé',
  account_deleted_error: 'Erreur durant la suppression du compte',
  program_saved: 'Programme sauvegardé',
  program_saved_error: 'Erreur durant la sauvegarde du programme',
  program_deleted: 'Programme supprimé',
  program_deleted_error: 'Erreur durant la suppression du programme',
  product_saved: 'Produit sauvegardé',
  product_saved_error: 'Erreur durant la sauvegarde du produit',
  product_deleted: 'Produit supprimé',
  product_deleted_error: 'Erreur durant la suppression du produit',
  organisation_info_updated: 'Mise à jour de l\'organisation',
  organisation_info_updated_error: 'Erreur durant la mise à jour de l\'organisation',
  organisation_contact_updated: 'Mise à jour du contact de l\'organisation',
  organisation_contact_updated_error: 'Erreur durant mise à jour du contact de l\'organisation',
  tax_saved: 'Taxe sauvegardée',
  tax_saved_error: 'Erreur durant la sauvegarde de la taxe',
  deleted_tax: 'Supprimé la taxe',
  deleted_tax_error: 'Erreur durant la suppression de la taxe',
  notification_saved: 'Notification sauvegardée.',
  notification_saved_error: 'Erreur durant la sauvegarde de la notification.',
  deleted_notification_contact: 'Contact de notification supprimé.',
  deleted_notification_contact_error: 'Erreur durant la suppression du contact de notification.',
  successfully_uploaded: 'Chargé avec succès',
  error_upload: 'Erreur du téléchargement',
  replace_invoice: 'Cette facture sera annulée et une nouvelle sera crée.',
  purchased_success: 'Achat effectue avec succès.',
  payment_update_success: 'Paiement modifié avec succès.',
  payment_refund: 'Paiement rembourser avec succès.',
  payment_refund_error: 'Erreur lors du remboursement du paiement.',
  purchased_error: 'Erreur durant l\'achat.',
  file_not_found: 'File not found.',
  download_started: 'Téléchargement démarré',
  download_success: 'Téléchargement réussi',
  download_error: 'Erreur de téléchargement',
  download_notfound: 'Aucun résultat',
  processing: 'Traitement démarré',
  setting_saved: 'Paramètres sauvegardés avec succès.',
  setting_saved_error: 'Erreur lors de la sauvegarde des paramètres.',
  cancel_tax_receipt_success: 'Reçu d\'impôt annulé avec succès.',
  cancel_tax_receipt_error: 'Erreur lors de l\'annulation du reçu d\'impôt.',
  tax_receipt_sent: 'Reçu fiscal envoyé avec succès.',
  tax_receipt_sent_error: 'Erreur lors de l\'envoi du reçu fiscal.',
};

export default messages;
